import { Component } from '@angular/core'

@Component({
	selector: 'contact',
	templateUrl: './Contact.Component.html',
})
export class ContactComponent {}
